<div class="card-change-business">
    <div class="dialog-header">
      <div class="dialog-header-left">
        <div class="dialog-icon">
          <i class="fa-light"
            [ngClass]="{
              'fa-building': valueChange === 'nameCitylok' || valueChange === 'description',
              'fa-map-marker-alt': valueChange === 'address',
              'fa-link': valueChange === 'slug',
              'fa-file-contract': valueChange === 'general_conditions',
              'fa-coins': valueChange === 'ticket_office_fee'
            }"></i>
        </div>
        <div>
          <p class="title-change">{{nameValue}}</p>
          <p class="subtitle-change">Actualizar información de la organización</p>
        </div>
      </div>
      <button class="btn-close-dialog" mat-dialog-close>
        <i class="fa-light fa-times"></i>
      </button>
    </div>

    <div>
        <form [formGroup]="changeForm">
            <div *ngIf="valueChange == 'nameCitylok'">
              <p class="field-helper">Este nombre es el que verán los usuarios en la plataforma Citylok al buscar tu organización.</p>
              <div class="bloque-change-input container-form d-flex align-items-center password-input">
                <input class="w-100" type="text" placeholder="Nombre visible" formControlName="name" required>
              </div>
            </div>
            <p *ngIf="valueChange == 'slug'" class="field-helper">Personaliza la URL pública de tu organización. Usa solo letras minúsculas, números y guiones.</p>
            <div class="bloque-change-input container-form d-flex align-items-center password-input"
                *ngIf="valueChange == 'slug'"
                [ngClass]="{
                    error: changeForm.get('slug')?.invalid && changeForm.get('slug')?.touched
                }">
                <input class="w-100" type="text" placeholder="mi-url-personalizada" formControlName="slug" required>
            </div>
            <p class="field-error-text"
               *ngIf="valueChange == 'slug' && changeForm.get('slug')?.invalid && changeForm.get('slug')?.touched">
                Este campo es obligatorio.
            </p>
            <div *ngIf="valueChange == 'ticket_office_fee'">
              <p class="field-helper">Comisión que Citylok cobra por cada entrada despachada en taquilla (efectivo,
                datáfono y tótem), sin IVA. Déjala a 0 si este organizador no tiene comisión pactada: entonces no
                aparecerá en sus informes.</p>
              <div class="bloque-change-input container-form d-flex align-items-center password-input input-money">
                <input class="w-100" type="number" min="0" step="0.0001" placeholder="0,00"
                  formControlName="ticket_office_fee" required>
                <span class="ms-2">€</span>
              </div>
            </div>
            <div *ngIf="valueChange == 'address'">
                <p class="field-helper">Introduc la dirección postal completa de tu organización. Se usará para facturación y documentos legales.</p>
                <div class="address-form">
                  <div class="address-field">
                    <label class="input-label">Dirección</label>
                    <div class="bloque-change-input input-address container-form d-flex align-items-center password-input">
                        <textarea #textarea class="w-100" type="textarea" placeholder="Calle, número, piso..." maxlength="2500"
                            formControlName="address"></textarea>
                    </div>
                  </div>
                  <div class="address-row">
                    <div class="address-field">
                      <label class="input-label">Ciudad</label>
                      <div class="bloque-change-input container-form d-flex align-items-center password-input">
                          <input class="w-100" type="text" placeholder="Madrid" formControlName="city" required>
                      </div>
                    </div>
                    <div class="address-field">
                      <label class="input-label">Código postal</label>
                      <div class="bloque-change-input container-form d-flex align-items-center password-input">
                          <input class="w-100" type="text" placeholder="28001" formControlName="postal_code" required>
                      </div>
                    </div>
                  </div>
                  <div class="address-field">
                    <label class="input-label">Provincia</label>
                    <mat-form-field appearance="fill" class="custom-mat-select">
                      <mat-select formControlName="id_state" placeholder="Selecciona una provincia" [compareWith]="compareById">
                          <mat-option *ngFor="let state of states" [value]="state.id">
                          {{ state.name }}
                          </mat-option>
                      </mat-select>
                      <mat-select-trigger matSuffix style="margin-right: 10px;">
                              <i class="fal fa-angle-down pointer-in"></i>
                          </mat-select-trigger>
                    </mat-form-field>
                  </div>
                  <div class="address-field">
                    <label class="input-label">País</label>
                    <mat-form-field appearance="fill" class="custom-mat-select">
                      <mat-select formControlName="id_country" placeholder="Selecciona un país" [compareWith]="compareById">
                          <mat-option *ngFor="let country of countries" [value]="country.id">
                          {{ country.name }}
                          </mat-option>
                      </mat-select>
                      <mat-select-trigger matSuffix style="margin-right: 10px;">
                              <i class="fal fa-angle-down pointer-in"></i>
                          </mat-select-trigger>
                    </mat-form-field>
                  </div>
                </div>
            </div>

            <angular-editor *ngIf="valueChange == 'description'" #edit id="2"
                formControlName="description" [config]="editorConfigBusiness">
            </angular-editor>

            <angular-editor *ngIf="valueChange == 'general_conditions'" #edit id="2"
                formControlName="general_conditions" [config]="editorConfigBusiness">
            </angular-editor>

            <div class="d-flex gap-2 justify-content-center btn-change">
                <button class="primary-button solid w-50" style="min-height: 40px;"
                    (click)="changeBusiness()">Guardar</button>
            </div>
        </form>
    </div>
</div>